import axios from 'axios';
import { configRefs } from '@utils/constants';

/**
 * Determines all the products that a given user is authorized to access.
 */
async function getAuthorizedProductsForUser(user) {
  const authorizedIsbnSet = new Set();

  // Determine all the products that the given user is authorized to access,
  // using either eKey or unic depending on provider.
  if (user.authenticationProvider === "ekey") {
    const {
      data: ekeyDetails
    } = await axios.get(`${(await configRefs.apis.gas.get())?.replaceAll("{{version}}", "v")}/api/User/GetEkeyUserDetailsByEmail?userEmail=${user.id}`);
    const {
      data
    } = await axios.get(`${(await configRefs.apis.gas.get())?.replaceAll("{{version}}", "v")}/api/License/GetProductLicensesByUser?ekeyUserId=${ekeyDetails.UserId}`);
    for (const element of data) {
      authorizedIsbnSet.add(element.Product.Isbn);
    }
  } else {
    const {
      data: products
    } = await axios.get(`${(await configRefs.apis.gas.get())?.replaceAll("{{version}}", "v1")}/api/v1/Unic/Products/User/${user.id}`);
    for (const product of products) {
      authorizedIsbnSet.add(product.Id);
    }
  }
  return authorizedIsbnSet;
}

export { getAuthorizedProductsForUser };
//# sourceMappingURL=api.get-authorized-products-for-user.js.map
